import * as Sentry from '@sentry/react';
import { TooltipProvider } from '@/components/ui/tooltip';
import App from './App.tsx';

const isDevelopment = import.meta.env.DEV;

function logFrontendIncident(error: unknown, context: string, details?: unknown) {
  if (!isDevelopment) {
    return;
  }

  console.error(`[frontend:${context}]`, error, details);
}

export function AppTree() {
  return (
    <TooltipProvider>
      {isDevelopment ? (
        <App />
      ) : (
        <Sentry.ErrorBoundary
          onError={(error, componentStack, eventId) => {
            logFrontendIncident(error, 'error-boundary', {
              componentStack,
              eventId,
            });
          }}
          fallback={(
            <main className="flex min-h-screen items-center justify-center bg-[linear-gradient(180deg,rgba(247,248,250,1)_0%,rgba(239,243,246,1)_100%)] px-6 dark:bg-none dark:bg-background">
              <section className="w-full max-w-lg rounded-[var(--radius-surface-4xl)] border border-white/70 bg-white/90 p-8 shadow-[0_30px_80px_rgba(15,23,42,0.08)] backdrop-blur dark:border-border dark:bg-card dark:shadow-none">
                <div className="space-y-4 text-center">
                  <p className="text-sm font-medium uppercase tracking-[0.3em] text-slate-500 dark:text-muted-foreground">Incident UI</p>
                  <h1 className="text-2xl font-semibold text-slate-950 dark:text-foreground">Une erreur a interrompu l interface.</h1>
                  <p className="text-sm leading-6 text-slate-600 dark:text-muted-foreground">
                    L incident a ete transmis a Sentry. Recharge la page pour reprendre une session propre.
                  </p>
                  <button
                    type="button"
                    onClick={() => window.location.reload()}
                    className="inline-flex items-center justify-center rounded-full bg-slate-950 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-slate-800 dark:bg-foreground dark:text-background dark:hover:bg-foreground/85"
                  >
                    Recharger l application
                  </button>
                </div>
              </section>
            </main>
          )}
        >
          <App />
        </Sentry.ErrorBoundary>
      )}
    </TooltipProvider>
  );
}
